import { Col, Row } from 'antd';
import { FormikContextType, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { PAYMENT_SYSTEMS, i18, translationGroups, trb } from 'src/Utilities';
import { FormField, ToggleButton } from 'src/shared';
import { BICS_SET_1 } from '../../../../../constants';

export const FieldPaymentSystem = ({ paymentSystemStatic }: { paymentSystemStatic?: boolean }) => {
  const { checkIBANResult } = useSelector((state: any) => state.PMCReducers);
  const { setFieldValue, values }: FormikContextType<any> = useFormikContext<any>();
  const isInstantPayment = (!BICS_SET_1.includes(values?.Payment?.BIC) && checkIBANResult?.Participant?.SepaInst) ?? false;

  useEffect(() => {
    if (!paymentSystemStatic) {
      setFieldValue('Payment.PaymentSystem', isInstantPayment ? PAYMENT_SYSTEMS.INST : (values?.Payment?.PaymentSystem ?? PAYMENT_SYSTEMS.SEPA));
    }
  }, [values?.Payment?.BeneficiaryAccountNumber]);

  if (values.Payment.PaymentFormType === 'template') {
    return null;
  }

  return (
    <Row align="middle">
      <Col
        className="my-1"
        span={24}
        xl={10}
      >
        {trb(i18.Labels.PaymentType)}
      </Col>
      <Col
        span={24}
        xl={14}
      >
        <FormField
          name="Payment.PaymentSystem"
          floating={false}
        >
          <ToggleButton
            options={[
              {
                label: trb(translationGroups.PaymentTypeSepa + 'SCT'),
                value: 'SepaSct',
              },
              {
                label: trb(translationGroups.PaymentTypeSepa + 'Inst'),
                value: 'INST',
                disabled: !isInstantPayment,
              },
            ]}
          />
        </FormField>
      </Col>
    </Row>
  );
};
